import { SearchInput, SelectInput } from "react-admin";

export const ProviderFilters = [
  <SearchInput
    key="search"
    source="search"
    placeholder="Search by name or code"
    alwaysOn
  />,
  <SelectInput
    key="status"
    source="status"
    choices={[
      { id: "active", name: "Active" },
      { id: "inactive", name: "Inactive" },
      { id: "maintenance", name: "Maintenance" },
      { id: "deprecated", name: "Deprecated" },
    ]}
    alwaysOn
  />,
  <SelectInput
    key="type"
    source="type"
    choices={[
      { id: "hotel", name: "Hotel" },
      { id: "flight", name: "Flight" },
      { id: "car_rental", name: "Car Rental" },
      { id: "activity", name: "Activity" },
      { id: "package", name: "Package" },
    ]}
  />,
];
